module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-3-1dbb2cdf493b5bed9e93df80a04685fa.jpg";